<vi-loader
  data-at-loader
  *ngIf="featuresLoading$ | async"
  [isLoading]="true"
  [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
></vi-loader>

<!-- low battery info -->
<ng-container *ngIf="battery$ | async | ready as battery">
  <ng-container
    *ngIf="
      battery.properties?.level?.value !== null &&
      battery.properties?.level?.value < lowBatteryThreshold
    "
  >
    <div class="low-battery-wrapper">
      <vi-icon name="battery-low-src" [size]="16"></vi-icon>
      <span> {{ '+INSTALLATIONS.SRC.LOW_BATTERY' | translate }} </span>
    </div>
  </ng-container>
</ng-container>

<!-- device name -->
<ng-container *ngIf="deviceName$ | async | ready as deviceName">
  <app-feature-list-item
    data-at-device-name
    [label]="'+INSTALLATIONS.SRC.DEVICE.DESCRIPTION' | translate"
    [editable]="true"
    [value]="deviceName | value2: featurePropertyKey.name"
    (edit)="openEditDeviceNameDialog(deviceId)"
  >
  </app-feature-list-item>
</ng-container>

<!-- id -->
<app-feature-list-item
  data-at-id
  [label]="'+INSTALLATIONS.SRC.DEVICE.ID' | translate"
  [value]="deviceId | idPrefixRemover | serialSpacing"
>
</app-feature-list-item>

<!-- device error info message -->
<ng-container *ngIf="deviceErrors$ | async as deviceErrors">
  <app-feature-list-item
    data-ut-error
    *ngFor="let error of deviceErrors"
    [label]="error?.errorCode"
    [description]="error?.errorDescription"
    [value]="error?.appearedAt | date: 'short'"
    [error]="true"
  >
  </app-feature-list-item>
</ng-container>

<!-- Device disconnected alert -->
<ng-container *ngIf="status$ | async | ready as status">
  <!-- Device disconnected alert -->
  <app-feature-list-item
    *ngIf="installationService.isSrcDeviceNotConnected(status)"
    [isNgContent]="true"
  >
    <app-banner>
      {{ '+INSTALLATIONS.SRC.ETRV.DISCONNECTED' | translate: { time: status.timestamp | date:
      'short' } }}
    </app-banner>
  </app-feature-list-item>

  <!-- wifi lqi -->
  <app-feature-list-item
    data-at-trv-wifi-lqi
    *ngIf="wifiLqi$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
    [isNgContent]="true"
    timestamp="{{ feature.timestamp | date: 'short' }}"
    [attr.data-feature]="feature.feature + '/strength'"
  >
    <ng-container
      *ngIf="
        feature.properties?.strength && feature.properties?.strength?.value < lowLqiSignalThreshold;
        then lowSignal;
        else stableSignal
      "
    ></ng-container>

    <ng-template #lowSignal>
      <span class="warning-box">
        <mat-icon>error</mat-icon>
        {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
        featurePropertyKey.strength) + ' ' + (feature | unit: featurePropertyKey.strength) }}</span
      >
    </ng-template>

    <ng-template #stableSignal>
      {{ installationService.isSrcDeviceNotConnected(status) ? noValue : (feature | value2:
      featurePropertyKey.strength) + ' ' + (feature | unit: featurePropertyKey.strength) }}
    </ng-template>
  </app-feature-list-item>

  <!-- device.power.battery -->
  <app-feature-list-item
    data-at-battery
    *ngIf="battery$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.BATTERY_STATUS' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.level) +
          ' ' +
          (feature | unit: featurePropertyKey.level)
    }}"
    [attr.data-feature]="feature.feature + '/level'"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- device.sensors.temperature -->
  <app-feature-list-item
    data-at-trv-sensor-temperature
    *ngIf="sensorTemperature$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.CURRENT_TEMPERATURE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.value) +
          ' ' +
          (feature | unit: featurePropertyKey.value)
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
    <!--      value="{{  }}"-->
  </app-feature-list-item>

  <!-- trv.temperature -->
  <app-feature-list-item
    data-at-trv-target-temperature
    *ngIf="temperature$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.TARGET_TEMPERATURE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.value) +
          ' ' +
          (feature | unit: featurePropertyKey.value)
    }}"
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- motor position -->
  <app-feature-list-item
    data-at-trv-motor
    *ngIf="motorPosition$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.ETRV.MOTOR_POSITION.TITLE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature.properties?.position?.value | translateValvePosition)
    }}"
    [attr.data-feature]="feature.feature + '/position'"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>

  <!-- device.heatingCircuitId -->
  <ng-container *ngIf="!(isSrcStandalone$ | async)?.properties?.active?.value">
    <app-feature-list-item
      data-at-heatingCircuitId
      *ngIf="heatingCircuitId$ | async | ready as feature"
      [error]="feature | error"
      [label]="'+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate"
      value="{{
        installationService.isSrcDeviceNotConnected(status)
          ? noValue
          : (installationService.getCircuitName(feature.properties?.value?.value.toString())
            | async)
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </ng-container>

  <!-- open point detection -->
  <ng-container *ngIf="openPointDetection$ | async | ready as feature">
    <app-feature-list-item
      *ngIf="isOpenPointDetectionActive"
      data-at-openPointDetection
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.ROOMS.OPEN_POINT_DETECTION.LABEL' | translate"
      [labelInfoTooltip]="
        '+INSTALLATIONS.INSTALLATION.ROOMS.OPEN_POINT_DETECTION.TOOLTIP' | translate
      "
      [isNgContent]="true"
      timestamp="{{ feature?.timestamp | date: 'short' }}"
      [attr.data-feature]="feature.feature"
    >
      <app-pill [type]="pillType.success">
        <ng-container>
          {{ '+INSTALLATIONS.INSTALLATION.ROOMS.OPEN_POINT_DETECTION.STATUS_ON' | translate }}
        </ng-container>
      </app-pill>
    </app-feature-list-item>
  </ng-container>
</ng-container>

<ng-container *ngIf="mountingMode$ | async | ready as mountingMode">
  <app-feature-list-item
    data-ut-alert
    *ngIf="mountingMode?.properties?.active?.value"
    label="{{ '+COMMISSIONING.DEVICE_INDICATOR.MOUNTING_MODE_WARNING.MESSAGE' | translate }}"
    [attr.data-feature]="mountingMode.feature"
    [error]="true"
  >
  </app-feature-list-item>

  <!-- device.sensors.firmware-->
  <app-feature-list-item
    data-at-cs-sensor-firmware
    *ngIf="firmware$ | async | ready as feature"
    [error]="feature | error"
    [label]="'+INSTALLATIONS.SRC.FIRMWARE' | translate"
    value="
      {{feature | value2: featurePropertyKey.value}}
    "
    [attr.data-feature]="feature.feature"
    timestamp="{{ feature.timestamp | date: 'short' }}"
  >
  </app-feature-list-item>
</ng-container>
